import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.function.name.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from 'components/Box';
import InlineList from 'components/InlineList';
import { TooltipPillWithCount, GoalPill } from 'components/Pill';
import Text from 'components/Text';
import ViewMoreText from 'components/ViewMoreText';
import FriendlyDuration from 'components/FriendlyDuration';
import config from 'utils/config';
import getContentProgress from 'utils/asset/getContentProgress';
import ContentProgressCircle from 'components/ContentProgressCircle';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export default function InfoSection(_ref) {
  var playlist = _ref.playlist;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var id = playlist.id,
    name = playlist.name,
    completionTime = playlist.completionTime,
    completionRate = playlist.completionRate,
    description = playlist.description,
    commentCount = playlist.commentCount,
    commentCountUser = playlist.commentCountUser,
    userContentStatus = playlist.userContentStatus,
    goal = playlist.goal,
    contentCount = playlist.contentCount;
  var progress = getContentProgress({
    isPlaylist: true,
    userContentStatus: userContentStatus,
    completionRate: completionRate
  });
  if (!id) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Box, {
      dimmed: true,
      mb: "m",
      children: /*#__PURE__*/_jsxs(InlineList, {
        splitBy: "dot",
        children: [t('content_type_playlist'), contentCount > 0 && t('playlist_item_count', {
          count: contentCount
        }), completionTime > 0 && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(FriendlyDuration, {
            value: completionTime * 60
          }), ' ', t('playlist_duration')]
        }), contentCount > 0 && /*#__PURE__*/_jsx(ContentProgressCircle, {
          progress: progress,
          contentName: name,
          infoReadout: "full"
        }), goal && /*#__PURE__*/_jsx(GoalPill, {
          goal: goal
        }), config.enableComments && !!commentCount && /*#__PURE__*/_jsx(TooltipPillWithCount, {
          "data-qa": "comment-count-pill",
          icon: "chat",
          highlightIcon: commentCountUser > 0,
          count: commentCount
        })]
      })
    }), description && /*#__PURE__*/_jsx(Text, {
      lineHeight: 1.9,
      mb: "m",
      overflow: "wrap",
      as: "div",
      children: /*#__PURE__*/_jsx(ViewMoreText, {
        content: description,
        maxLength: 180
      })
    })]
  });
}